import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import View from "./View";

const SignatureWaiting = ({ subscription, totalPrice }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.PROJECT);
  const TRANSLATION = t("DETAIL.TEMPLATES.LAFOURGALE.SUBSCRIPTION_DONE", {
    returnObjects: true,
  });

  return (
    <>
      <View
        totalPrice={totalPrice}
        subscription={subscription}
        translation={TRANSLATION}
      />
    </>
  );
};

export default SignatureWaiting;
